import { Routes, Route } from "react-router";
import Login from "../component/auth/Login";
import OptVerification from "../component/auth/OptVerification";
import Home from "../component/home";
import ForgotPassword from "../component/auth/ForgotPassword";
import ResetPassword from "../component/auth/ResetPassword";
import PdfViewer from "../component/pages/pdf/PdfViewer";
import { PageTypePath } from "utils/pages";
import UserAgreementPage from "component/pages/userAgreement/UserAgreement";
import SignatureForm from "../component/pages/signature/SignatureForm";

const CustomRouter = () => {
	return (
		<Routes>
			<Route path={"/login"} element={<Login />} />
			<Route path={"/auth/2fa/:token"} element={<OptVerification />} />
			<Route path={"/auth/verification/:type"} element={<OptVerification />} />
			<Route path={"/auth/forgot-password"} element={<ForgotPassword />} />
			<Route path={"/auth/reset-password"} element={<ResetPassword />} />
			{/* <Route path={`/brukeravtal`} element={<UserAgreementPage />} /> */}
			<Route
				path={`/${PageTypePath.UserAgreement.toString()}`}
				element={<UserAgreementPage />}
			/>

			{/*<Route path={"/signature/:id/"} element={<SignatureForm />} />*/}
			<Route path={"/pdf/:guid/"} element={<PdfViewer />} />
			<Route path={"/pdf/:id/:type"} element={<PdfViewer />} />
			<Route path={"/"} element={<Home />} />

			<Route path={"/:path/:id/:action"} element={<Home />} />
			<Route path={"/:path/:id"} element={<Home />} />
			<Route path={"/:path"} element={<Home />} />
		</Routes>
	);
};

export default CustomRouter;
